export class OpenMenu {
  static readonly type = '[Layout] Open Menu';
}

export class CloseMenu {
  static readonly type = '[Layout] Close Menu';
}

export class OpenNotification {
  static readonly type = '[Layout] Open Notification';
  constructor(
    public state: string,
    public message: string
  ){}
}

export class CloseNotification {
  static readonly type = '[Layout] Close Notification';
  constructor(
    public state: string,
    public message: string
  ){}
}

export class OpenTimer {
  static readonly type = '[Layout] Open Timer';
}

export class CloseTimer {
  static readonly type = '[Layout] Close Timer';
}

export class OpenEula {
  static readonly type = '[Layout] Open Eula';
}

export class CloseEula {
  static readonly type = '[Layout] Close Eula';
}
